import { AgeGroups, ViewTimeInference } from "@/dataprocessor/view-time";
import { InferenceSetup } from "@/inference/setup";
import { backgroundWorker } from "./worker";

export const Infer = {
  initialise() {
    Infer.oneTimeInfers();
    InferenceSetup.registerInterval(setInterval(Infer.repeatingInfers, 10_000));
  },

  repeatingInfers() {
    Infer.inferAgeFromMaxViewtime();
    Infer.ui();
    Infer.product();
  },

  oneTimeInfers() {
    Infer.inferFromScrollSpeed();
    Infer.inferFromDevice();
    Infer.inferFromAccessTime();
    Infer.inferFunnelStage();
  },

  inferAll: () => {},

  inferAge(
    age: AgeGroups,
    score: number,
    type: "viewTimeAge" | "deviceAge" | "accessTimeAge" | "scrollSpeedAge",
  ) {
    if (!ViewTimeInference.behavioralInference.age.details[age]) {
      ViewTimeInference.behavioralInference.age.details[age] = 0;
    }

    ViewTimeInference.behavioralInference[type].order = [age];

    ViewTimeInference.behavioralInference.age.details[age] += score;

    if (!ViewTimeInference.behavioralInference.age.order.includes(age)) {
      ViewTimeInference.behavioralInference.age.order.push(age);
    }

    ViewTimeInference.behavioralInference.age.order.sort(
      (a, b) =>
        ViewTimeInference.behavioralInference.age.details[b] -
        ViewTimeInference.behavioralInference.age.details[a],
    );
  },

  inferFunnelStage() {
    function checkAndInfer(
      stage: (typeof funnelStages)[keyof typeof funnelStages],
    ) {
      const funnelOrder = [
        funnelStages.VIEWER,
        funnelStages.PDP_VIEWER,
        funnelStages.ADD_TO_CART,
        funnelStages.CHECKOUT,
      ];

      if (
        funnelOrder.indexOf(stage) >
        funnelOrder.indexOf(localStorage.getItem("funnelStage"))
      ) {
        sessionStorage.setItem("funnelStage", stage);
      }

      console.log("STAGE OF THE FUNNEL CHANGED TO", stage);
    }

    const funnelStages = {
      VIEWER: "viewer",
      PDP_VIEWER: "pdp_viewer",
      ADD_TO_CART: "add_to_cart",
      CHECKOUT: "checkout",
    };

    if (window.location.pathname.includes("/products")) {
      checkAndInfer(funnelStages.PDP_VIEWER);
    } else checkAndInfer(funnelStages.VIEWER);

    const addToCartButtons = document.querySelectorAll("button[name='add']");

    addToCartButtons.forEach((button) => {
      button.addEventListener("click", () => {
        checkAndInfer(funnelStages.ADD_TO_CART);
      });
    });

    Array.from(document.querySelectorAll("button[name='checkout']"))
      .concat(
        Array.from(document.querySelectorAll("button[id='button-gokwik']")),
        Array.from(document.querySelectorAll("button")).filter(
          (button) =>
            button.textContent && /buy|checkout/i.test(button.textContent),
        ),
      )
      .forEach((button) => {
        button.addEventListener("click", () => {
          checkAndInfer(funnelStages.CHECKOUT);
          console.log("STAGE OF THE FUNNEL CHANGED TO CHECKOUT");
        });
      });
  },

  inferFromDevice() {
    const regex =
      /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

    const isMobile = regex.test(navigator.userAgent);

    if (isMobile) {
      Infer.inferAge("YOUNG", 5, "deviceAge");
    } else {
      Infer.inferAge("OLD", 5, "deviceAge");
    }
  },

  inferFromAccessTime() {
    const now = new Date();
    const hours = now.getHours();
    const day = now.getDay();

    const isWeekday = day >= 1 && day <= 5;

    const isEveningOrNight = hours >= 18 || hours <= 6;
    const isWorkingHours = hours >= 9 && hours <= 17;
    const isEarlyMorning = hours >= 6 && hours < 9;
    const isEarlyEvening = hours > 17 && hours < 18;

    if (isWeekday && isEveningOrNight) {
      Infer.inferAge("YOUNG", 5, "accessTimeAge");

      return;
    }

    if (isWeekday && isWorkingHours) {
      Infer.inferAge("MIDDLE", 5, "accessTimeAge");

      return;
    }

    if (isWeekday && (isEarlyMorning || isEarlyEvening)) {
      Infer.inferAge("OLD", 5, "accessTimeAge");

      return;
    }

    Infer.inferAge("OLD", 5, "accessTimeAge");
  },

  inferAgeFromMaxViewtime() {
    const maxViewTimeInSeconds =
      Object.keys(ViewTimeInference.totalViewTime).reduce(
        (acc, key) => Math.max(acc, ViewTimeInference.totalViewTime[key]),
        0,
      ) / 1000;

    if (maxViewTimeInSeconds > 5) {
      Infer.inferAge("OLD", 5, "viewTimeAge");
      return;
    }

    if (maxViewTimeInSeconds > 3) {
      Infer.inferAge("MIDDLE", 5, "viewTimeAge");
      return;
    }

    Infer.inferAge("YOUNG", 5, "viewTimeAge");
  },

  inferFromScrollSpeed() {
    const checkScrollSpeed = (function (settings) {
      settings = settings || {};

      let lastPos, newPos, timer, delta;
      const delay = settings.delay || 50;

      function clear() {
        lastPos = null;
        delta = 0;
      }

      clear();

      return function () {
        newPos = window.scrollY;
        if (lastPos != null) {
          delta = newPos - lastPos;
        }
        lastPos = newPos;
        clearTimeout(timer);
        timer = setTimeout(clear, delay);
        return Math.abs(delta);
      };
    })();

    window.addEventListener("scroll", function () {
      const speed = checkScrollSpeed();

      if (speed === 0) return;

      if (speed > 20) {
        Infer.inferAge("YOUNG", 3, "scrollSpeedAge");
      }

      if (speed < 20 && speed > 10) {
        Infer.inferAge("MIDDLE", 2, "scrollSpeedAge");
      }

      if (speed < 10) {
        Infer.inferAge("OLD", 1, "scrollSpeedAge");
      }
    });
  },

  ui: async () => {
    const obj = window.helium.sectionInfo;
    const sectionScores = ViewTimeInference.sectionScore;
    const currentInference = JSON.parse(
      JSON.stringify(ViewTimeInference.inference),
    );

    try {
      const nonNullSectionScores = Object.fromEntries(
        Object.entries(sectionScores).filter(([_, value]) => value !== 0),
      );

      if (Object.keys(nonNullSectionScores).length === 0) {
        return;
      }

      const {
        inference,
        categorySpecificScore,
        categoryScore,
        categorySpecificScoreFlattenedFinal,
      } = await backgroundWorker.send({
        sectionInfo: obj,
        sectionScores: nonNullSectionScores,
        currentInference,
        flattenedScoreTable: ViewTimeInference.flattenedScoreTable,
        categorySpecificScoreFlattened:
          ViewTimeInference.categorySpecificScoreFlattened,
      });

      if (categorySpecificScore && categoryScore) {
        ViewTimeInference.categorySpecificScore = categorySpecificScore;
        ViewTimeInference.categorySpecificScoreFlattened =
          categorySpecificScoreFlattenedFinal;
      }

      if (inference) {
        ViewTimeInference.inference = inference;

        Object.keys(ViewTimeInference.sectionScore).forEach((sectionId) => {
          ViewTimeInference.sectionScore[sectionId] = 0;
        });
      }

      InferenceSetup.persistInferenceLocally();

      return inference;
    } catch (error) {
      console.error("Error processing UI inference:", error);
      return null;
    }
  },

  product: () => {
    // window.helium.events.notify({ data: { type: "infer product intent" } });
  },

  cart: () => {},
  collection: () => {},
  tags: () => {},
};
